import { DoctorNames } from './DoctorNames';
import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import React from 'react';
import Timer from '../Timer';
import { config } from 'config';
import { dashboardActions } from 'core/Dashboard';
import isEmpty from 'lodash/isEmpty';
import minBy from 'lodash/minBy';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    FullName,
    Info,
    PhoneType,
    Status,
    StatusContainer,
    Text,
    TrackingContainer,
    Underline
} from './styled';
import {
    isLocked,
    minutesFormat,
    parseNotSucceded
} from 'shared/utils';
import {
    useDispatch,
    useSelector
} from 'hooks';
const {
    inCallHoursDisconnection,
    showPatientTurnaroundTime,
    showPatientWaitingDuration
} = config;

const CallItem = ({
    item
}) => {

    const dispatch = useDispatch();
    const { user } = useSelector('account');
    const { push } = useHistory();
    const { t } = useTranslation();

    const blockPatientData = !isLocked(user, 'call_data');

    const { secondaryColor } = useTheme();

    const {
        call_id,
        caller_first_name,
        caller_last_name,
        created_at,
        doctors,
        duration,
        patient_identification,
        patient_first_name,
        patient_last_name,
        patient_turnaround_time,
        patient_waiting_duration,
        pin,
        status,
        type
    } = item;

    const fullName = `${ !!patient_last_name ? patient_last_name : caller_last_name }, ${ !!patient_first_name ? patient_first_name : caller_first_name }`;
    const identification = patient_identification ? `${ t('DNI') } ${ patient_identification }` : undefined;

    const inCallCalls = !!doctors && doctors.length > 0 ? doctors.filter(({ status: { inCall } }) => !!inCall) : [];
    
    const { call_started_at: firstUpdatedInCall } = inCallCalls.length > 0
        ? minBy(inCallCalls, call => call?.call_started_at)
        : { };
    
    const {
        call_reason,
        status: {
            color,
            completing,
            disconnected,
            icon,
            iconSize,
            notSucceded,
            omitted,
            statusLabel,
            successful,
            waitingRoom
        }
    } = inCallCalls.length > 0
        ? inCallCalls[0]
        : doctors.length > 0
            ? doctors[0]
            : { call_reason: '', status: {} };

    const { pin: pinText } = pin ?? {};

    const handleItemClick = () => {
        const path = type === 'evolution' ? t('evolucion') : t('registro');
        push(`${ t('/pacientes') }/${ path }/${ call_id }`);
    };

    return (
        <Container>
            <Info>
                <div>
                    <FullName
                        onClick={
                            !!blockPatientData && (completing || omitted || successful || type === 'evolution')
                                ? handleItemClick
                                : null
                        }
                    >
                        { fullName }
                    </FullName>
                    <Text>
                        {
                            !!identification
                                ? identification
                                : `(${ t('Interconsulta') })`
                        }
                    </Text>
                    <DoctorNames callId={ call_id } doctors={ doctors } pin={ pin } waitingRoom={ !!waitingRoom } />
                    <StatusContainer>
                        {
                            !!blockPatientData && type !== 'evolution' &&
                            <TrackingContainer onClick={ () => dispatch(dashboardActions.getDashboardTracking(call_id)) }>
                                <MaterialIcon color={ color } icon="timeline" size={ 16 } />
                            </TrackingContainer>
                        }
                        {
                            status &&
                            <Status color={ color }>
                                { statusLabel }
                                {
                                    inCallCalls.length > 0 && firstUpdatedInCall
                                        ? <Timer
                                            from={ firstUpdatedInCall }
                                            max={ inCallHoursDisconnection * 3600 }
                                            onMax={ () => dispatch(dashboardActions.setDashboardRefreshCalls(true)) }
                                        />
                                        : !!created_at
                                            ? ` - ${ moment(created_at).format('DD/MM/YYYY HH:mm') }
                                                ${ (!!successful || !!omitted || !!disconnected) && !!duration ? ` - ${ minutesFormat(duration) } ` : '' } `
                                            : ''
                                }
                                {
                                    !!showPatientWaitingDuration &&
                                    !!patient_waiting_duration &&
                                    type === 'call' &&
                                    `(${ t('En espera') }: ${ minutesFormat(patient_waiting_duration) })`
                                }
                                {
                                    !!showPatientTurnaroundTime &&
                                    !!patient_turnaround_time &&
                                    type === 'call' &&
                                    `(${ t('Espera hasta interacción') }: ${ minutesFormat(patient_turnaround_time) })`
                                }
                                {
                                    (status === 'En espera' && !isEmpty(pin))
                                        ? ` - PIN: ${ pinText }`
                                        : ''
                                }
                            </Status>
                        }
                    </StatusContainer>
                    {
                        !!omitted && !!call_reason &&
                        <Text>
                            <Underline>{ t('Comentarios') }</Underline>: { call_reason }
                        </Text>
                    }
                    {
                        !!notSucceded && !!call_reason &&
                        <Text>
                            <Underline>{ t('Razón') }</Underline>: { parseNotSucceded(call_reason) }
                        </Text>
                    }
                </div>
            </Info>
            <PhoneType topOffset={ iconSize === 40 ? 25 : 15 } >
                {
                    !!icon &&
                    <MaterialIcon
                        color={ !!color ? color : secondaryColor }
                        icon={ icon }
                        size={ !!iconSize ? iconSize : 24 }
                    />
                }
            </PhoneType>
        </Container>
    );
};

CallItem.propTypes = {
    item: PropTypes.object
};

export default CallItem;
